import { Component, OnInit, ViewChild, ElementRef, Input, forwardRef, ChangeDetectorRef, NgZone } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { HttpRequestService } from 'src/app/services/http-request.service';
import { HttpResult } from 'src/app/models/Commons/HttpResult';
import { List } from 'src/app/models/Commons/List';
import { ValueTransformer } from '@angular/compiler/src/util';

declare var $;
@Component({
  selector: 'app-selectivity',
  templateUrl: './selectivity.component.html',
  styleUrls: ['./selectivity.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectivityComponent),
      multi: true
    }
  ]
})
export class SelectivityComponent implements OnInit, ControlValueAccessor {
  @Input()
  public options: Array<SelectivityOption> = [];
  @Input()
  public placeholder: string;
  @Input()
  public allowClear: boolean;
  @Input()
  public fromurl = null;
  @Input()
  public ngStyle = {
    'width': '200px'
  };
  //当前显示的数据
  private currentItemData: Array<any> = [];
  public isTree = false;
  constructor(private httpRequestService: HttpRequestService) { }

  ngOnInit() {
    if (this.fromurl != null) {
      this.loadTreeFromUrl(this.fromurl);
    }
  }

  //从url加载树
  public loadTreeFromUrl(opt) {
    var option = {
      action: null,
      method: null,
      postData: null,
      idField: "id",
      textField: "text",
      parentField: null,
      placeholder: "请选择",
      allowClear: true
    }
    $.extend(option, opt);
    this.isTree = option.parentField != null; //如果存在父级过滤，则使用树选择器
    this.fromurl = option;
    this.placeholder = option.placeholder;
    this.allowClear = option.allowClear;
    this.httpRequestService.httpRequest(option.action, option.method, option.postData)
      .subscribe((result: HttpResult<Array<any>>) => {
        if (result.code == 0) {
          this.options = [];
          this.currentItemData = result.data;
          var tmpTreeData: List<any> = new List<any>();
          tmpTreeData.pushRange(result.data);
          this.options = this.loadChildNodes(tmpTreeData, 0, option.idField, option.textField, option.parentField);
          if (tmpTreeData.length() == 0) {
            //加载后没有值，清除所有数据。
            this._selectValue = null;
            this._defaultValue = null;
            this.onModelChange(this._selectValue);
            return;
          }
          if ((option.action) == "companyAction") {
            let key = option.idField;
            this.selectValue = (this.currentItemData)[0][key];
          } else {
            if (tmpTreeData.has(x => {
              return x[option.idField] == this._defaultValue;
            })) {
              //加载后选项中找到了默认值
              this._selectValue = this._defaultValue == null ? null : this._defaultValue.toString();
              this.onModelChange(this._selectValue);
            } else {
              //加载后没有值，清除所有数据。
              this._selectValue = null;
              this._defaultValue = null;
              this.onModelChange(this._selectValue);
            }
          }

        }
      });
  }


  private loadChildNodes(tmpTreeData: List<any>, parentid, idField, textField, parentField): Array<SelectivityOption> {
    var currentLevel = tmpTreeData.select(x => {
      if (parentField == null)
        return true;
      else
        return x[parentField] == parentid;
    })
    var currentOptions: Array<SelectivityOption> = [];
    var currentLevelData = currentLevel.toArray();
    for (var i in currentLevelData) {
      var item = {
        key: currentLevelData[i][idField] + "",
        title: currentLevelData[i][textField] + "",
        isLeaf: false,
        children: parentField == null ? null : this.loadChildNodes(tmpTreeData, currentLevelData[i][idField], idField, textField, parentField)
      }
      if (item.children != null && item.children.length == 0) {
        item.isLeaf = true;
      }
      currentOptions.push(item);
    }
    return currentOptions;
  }
  //根据ID获取data
  public getDataById(id, idField) {
    for (var i in this.currentItemData) {
      if (this.currentItemData[i][idField] == id)
        return this.currentItemData[i];
    }
    return null;
  }
  //ngModel相关
  public onModelChange: Function = () => { };
  private _defaultValue = null;
  private _selectValue: string = null;
  public get selectValue(): string {
    return this._selectValue;
  }
  public set selectValue(value: string) {
    (typeof value === 'undefined' || value == "") && (value = null)
    if (this.options.length == 0) {
      this._defaultValue = value == null ? null : value.toString();
    } else {
      this._selectValue = value == null ? null : value.toString();
      this.onModelChange(value);
    }

  }



  writeValue(obj: any): void {
    if (typeof obj === 'undefined')
      obj = null;
    this.selectValue = obj;
  }
  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void {
  }
}
export class SelectivityOption {
  public key: any;
  public title: string;
  public isLeaf: boolean;
  public children: Array<SelectivityOption>;
}
